const dataLayer = window.dataLayer || [];

let universalGTM = (options, callback = null) => {
    const defaultObj = {
        event:'universal_event',
        universal_event_systems: 'google_analytics, facebook, metrika, vkontakte',
        event_category: 'тесты'
    };

    if (callback) {
        dataLayer.push(Object.assign(defaultObj, options, callback()))
    } else {
        dataLayer.push(Object.assign(defaultObj, options))
    }
};

export default universalGTM;